import { ManagePracticeService } from './../manage-practice.service';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { empty } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CounselorResolverService  implements Resolve<any> {
  constructor(private managePracticeService: ManagePracticeService) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
   
    if (route.data['counselorList']) {
    
      return this.managePracticeService.getCounselorList().pipe(
        
        catchError((error) => {
        
          return empty();
        })
      );
    }
    else if(route.data['editCounselor']){
    
      return this.managePracticeService.getCounselor(route.params.id||0).pipe(
        catchError((error) => {
         
          return empty();
        })
      );
    }
  }
}